import { combineReducers } from "redux";
import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";

import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import apiConfig from "../app/api/apiConfig";
import authReducer from "./slice/persist/authSlice";
import sidebarReducer from "./slice/nonPersist/sidebarSlice";
import dropdownSelectorReducer from "./slice/persist/dropdownSelector";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

const rootReducer = combineReducers({
  auth: authReducer,
  sidebar: sidebarReducer,
  dropdownSelector: dropdownSelectorReducer,
  [apiConfig.reducerPath]: apiConfig.reducer,
});

const nonPersistedSlices: string[] = ["sidebar"];

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  blacklist: [apiConfig.reducerPath, ...nonPersistedSlices],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(apiConfig.middleware),
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
